const HeartMarker = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#D11F44">
    <path d="M5.5 0A5.507 5.507 0 0 0 0 5.5a5.444 5.444 0 0 0 1.108 3.3s.15.197.174.226L5.5 14l4.22-4.976c.022-.027.172-.224.172-.224v-.001A5.442 5.442 0 0 0 11 5.5 5.507 5.507 0 0 0 5.5 0Zm2.105 5.851L5.501 8 3.395 5.851a1.4 1.4 0 0 1 0-1.948 1.33 1.33 0 0 1 1.908 0l.198.203.197-.203a1.33 1.33 0 0 1 1.907 0 1.4 1.4 0 0 1 0 1.948Z" />
  </svg>
);

export default HeartMarker;
